// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFoundView_wrapper__YaynQ","imageWrapper":"NotFoundView_imageWrapper__u6CYx"};